import { CompanyRegistrationRequest } from 'feature/company/types'
import { CompanyRegistrationFormValues } from 'feature/company/types/CompanyRegistrationForm'
import { companyRegistrationStorage } from '../storage/companyRegistrationStorage'

export const isStep1Complete = (data: CompanyRegistrationFormValues) =>
  !!(
    data.email &&
    data.firstName &&
    data.lastName &&
    data.agreeProcessingPersonalData
  )

export const getDefaultValues = (): CompanyRegistrationFormValues => ({
  email: companyRegistrationStorage.loadEmail(),
  firstName: '',
  lastName: '',
  fatherName: null,
  agreeProcessingPersonalData: false,
  agreeSubscribeAdvertising: false,
  companyName: '',
  inn: '',
  kpp: null,
  ogrn: '',
  legalAddress: null,
  actualAddress: null,
  directorFullName: '',
  directorPosition: '',
  bankDetails: {
    bankName: '',
    bik: '',
    correspondentAccount: '',
    currentAccount: '',
  },
  clientSubtype: 'ie',
  documentFileUids: [],
  documentsValid: false,
})

export const buildRequestData = (
  values: CompanyRegistrationFormValues,
): CompanyRegistrationRequest => ({
  email: values.email,
  firstName: values.firstName,
  lastName: values.lastName,
  fatherName: values.fatherName || undefined,
  customerAddress: values.actualAddress,
  agreeProcessingPersonalData: values.agreeProcessingPersonalData,
  agreeSubscribeAdvertising: values.agreeSubscribeAdvertising || false,
  companyName: values.companyName,
  inn: String(values.inn),
  kpp:
    values.clientSubtype === 'ie'
      ? null
      : values.kpp
      ? String(values.kpp)
      : undefined,
  ogrn: String(values.ogrn),
  legalAddress: values.legalAddress,
  actualAddress: values.actualAddress,
  directorFullName: values.directorFullName,
  directorPosition: values.directorPosition,
  bankDetails: [
    {
      bankName: values.bankDetails.bankName,
      bik: String(values.bankDetails.bik),
      correspondentAccount: String(values.bankDetails.correspondentAccount),
      currentAccount: String(values.bankDetails.currentAccount),
    },
  ],
  clientSubtype: values.clientSubtype,
  documentFileUids: values.documentFileUids,
})
